export const SKILLS_PATH_NAME = 'skills';

export const SKILL_BODY_MAX_BYTES = 32 * 1024;

export const SKILL_NAME_MAX_LENGTH = 120;

export const SKILL_DESCRIPTION_MAX_LENGTH = 800;

export const SKILL_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{1,62}[a-z0-9]$/;

export const SKILL_TENANT_MAX_COUNT = 100;

export const MAIN_COPILOT_AGENT_ID = 'copilot' as const;

export const KNOWN_SKILL_AGENT_IDS = [
  MAIN_COPILOT_AGENT_ID,
  'operator',
  'object-creator',
  'background-attack',
  'application-data-analyst',
  'recon',
  'code-analyst',
  'skill-builder',
  'terra-assistant',
  'trace-investigator',
  'signal-gen',
] as const;

export type KnownSkillAgentId = (typeof KNOWN_SKILL_AGENT_IDS)[number];

export const COPILOT_SKILL_AGENT_IDS = [
  MAIN_COPILOT_AGENT_ID,
  'operator',
  'object-creator',
  'background-attack',
  'application-data-analyst',
  'recon',
  'code-analyst',
  'skill-builder',
] as const satisfies readonly KnownSkillAgentId[];

export type CoPilotSkillAgentId = (typeof COPILOT_SKILL_AGENT_IDS)[number];

export const isCoPilotSkillAgentId = (
  agentId: string,
): agentId is CoPilotSkillAgentId =>
  COPILOT_SKILL_AGENT_IDS.some((knownAgentId) => knownAgentId === agentId);
